import * as React from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import * as moment from 'moment'
import * as ReactDatetime from 'react-datetime'

type Props = {
    kedo: any
    state: any
    setPartialState: (updates: any) => void
}

export const StepTwo = ({ kedo, state, setPartialState }: Props) => {
    const isValidDate = (current: moment.Moment) => current.isAfter(moment())

    const secureKedocxs = state.kedocxs.filter(
        (item) =>
            Array.isArray(state.secureShareSettings?.kedocx) &&
            state.secureShareSettings.kedocx.includes(item.id)
    )

    return (
        <Row>
            <Col md={6}>
                <strong>
                    {kedo.t('step_two_title', { ns: 'secureshare' })}
                </strong>
                <p>{kedo.t('step_two_description', { ns: 'secureshare' })}</p>
            </Col>
            <Col md={6}>
                <fieldset>
                    <legend>
                        {kedo.t('What do you want to share?', {
                            ns: 'secureshare',
                        })}
                    </legend>
                    <Form.Group>
                        <Form.Check
                            type="radio"
                            name="share_type"
                            value="positions"
                            label={kedo.t('Data position of this dossier', {
                                ns: 'secureshare',
                            })}
                            checked={state.shareType === 'positions'}
                            onChange={() =>
                                setPartialState({ shareType: 'positions' })
                            }
                        />
                        <Form.Check
                            type="radio"
                            name="share_type"
                            value="kedocx"
                            label={kedo.t('Template (kedocx)', {
                                ns: 'secureshare',
                            })}
                            checked={state.shareType === 'kedocx'}
                            disabled={!state.hasKedocxs}
                            onChange={() =>
                                setPartialState({ shareType: 'kedocx' })
                            }
                        />
                    </Form.Group>

                    {state.shareType === 'positions' && (
                        <Form.Group>
                            <Form.Label>
                                {kedo.t('Select position', {
                                    ns: 'secureshare',
                                })}
                            </Form.Label>
                            <Form.Control
                                as="select"
                                value={state.shareTypeValue}
                                onChange={(e) =>
                                    setPartialState({
                                        shareTypeValue: e.target.value,
                                    })
                                }
                            >
                                <option value="">
                                    {kedo.t('Choose an option')}
                                </option>
                                {state.displayPositions.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {kedo.translateItem(
                                            item,
                                            'displayposition'
                                        )}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    )}

                    {state.shareType === 'kedocx' && (
                        <Form.Group>
                            <Form.Label>{kedo.t('Select kedocx')}</Form.Label>
                            <Form.Control
                                as="select"
                                value={state.shareTypeValue}
                                onChange={(e) =>
                                    setPartialState({
                                        shareTypeValue: e.target.value,
                                    })
                                }
                            >
                                <option value="">
                                    {kedo.t('Choose an option')}
                                </option>
                                {secureKedocxs.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    )}
                </fieldset>

                <fieldset>
                    <legend>
                        {kedo.t('How long is the link valid?', {
                            ns: 'secureshare',
                        })}
                    </legend>
                    <Form.Group>
                        <ReactDatetime
                            closeOnSelect
                            timeFormat={false}
                            value={state.shareUntilDate}
                            isValidDate={isValidDate}
                            onChange={(date) =>
                                setPartialState({ shareUntilDate: date })
                            }
                        />
                    </Form.Group>
                </fieldset>
            </Col>
        </Row>
    )
}
